import { AlertRegular, PremiumRegular, SettingsRegular } from '@fluentui/react-icons';
import { CalendarTodoRegular } from '@fluentui/react-brand-icons';
import getGlobalSettingsAccountMailboxInfo from 'owa-account-source-list-store/lib/selectors/getGlobalSettingsAccountMailboxInfo';
import { getUnseenItemsCount } from 'owa-activity-feed/lib/store/unseenItemsSelector';
import { logUsage } from 'owa-analytics';
import loc from 'owa-localize';
import { lazyMountAndShowFullOptions } from 'owa-options-view';
import { isPremiumConsumer } from 'owa-session-store';
import { isTimePanelAvailable } from 'owa-time-panel-bootstrap';
import { lazyOpenPremiumDashboard } from 'owa-whats-new';
import type { OwaHeaderButtonControl } from '../../types/OwaHeaderButtonControl';
import getDrawerPaneId from 'owa-app-pane-group-utils/lib/getDrawerPaneId';
import onMyDayButtonClicked from '../../utils/onMyDayButtonClicked';
import MyDayPane from '../panes/MyDayPane';
import NotificationsPane from '../panes/NotificationsPane';
import {
    myDayHeaderButton,
    notificationsHeaderButton,
    premiumHeaderButton,
    settingsHeaderButton,
} from './OwaHeaderButton.locstring.json';

/*
 * The order of the buttons in this array is important.
 * The buttons are rendered in the order they are defined here from left to right.
 */
export const headerButtons: readonly OwaHeaderButtonControl[] = [
    {
        id: 'owaPremiumBtn_container',
        renderLabel: () => loc(premiumHeaderButton),
        renderIcon: () => <PremiumRegular />,
        onClick: () => {
            logUsage('HeaderPremiumDiamondClicked');
            lazyOpenPremiumDashboard.importAndExecute();
        },
        isVisible: () => isPremiumConsumer(getGlobalSettingsAccountMailboxInfo()),
    },
    {
        id: 'owaTimePanelBtn_container',
        renderLabel: () => loc(myDayHeaderButton),
        renderIcon: () => <CalendarTodoRegular />,
        onClick: () => onMyDayButtonClicked(),
        isVisible: () => isTimePanelAvailable(),
        pane: {
            id: getDrawerPaneId('myDay'),
            render: id => <MyDayPane paneId={id} />,
        },
    },
    {
        id: 'owaActivityFeedButton_container',
        renderLabel: () => loc(notificationsHeaderButton),
        renderIcon: () => <AlertRegular />,
        pane: {
            id: getDrawerPaneId('notifications'),
            render: id => <NotificationsPane paneId={id} />,
        },
        badge: {
            getCount: () => {
                return getUnseenItemsCount();
            },
        },
    },
    {
        id: 'owaSettingsBtn_container',
        renderLabel: () => loc(settingsHeaderButton),
        renderIcon: () => <SettingsRegular />,
        onClick: () => lazyMountAndShowFullOptions.importAndExecute(),
    },
] as const;
